
export function tieneModulo(state) {
    return function(codigo) {
        const { vigente, modulos } = state.suscripcion || {}
        if (!vigente) return false
        return Array.isArray(modulos) && modulos.some(m => m.codigo === codigo)
    }
}

export function tieneFeature(state) {
    return function(codigo) {
        const { vigente, features } = state.suscripcion || {}
        if (!vigente) return false
        return Array.isArray(features) && features.some(f => f.codigo === codigo)
    }
}

// Servicios adicionales contratados (add-ons, ej. `vitrina`): no dependen del plan.
export function tieneServicio(state) {
    return function(codigo) {
        const { vigente, servicios } = state.suscripcion || {}
        if (!vigente) return false
        return Array.isArray(servicios) && servicios.some(s => s.codigo === codigo)
    }
}

export function tienePermiso(state) {
    return function(codigo) {
        const role = state.user.role || [];
        if (role.includes('owner') || role.includes('admin')) return true;
        return Array.isArray(state.permisos) && state.permisos.includes(codigo);
    };
}

export function isOwner(state) {
    const user = state.user;
    return !!(user && user.role && user.role.includes('owner'));
}

export function userEsEmpleado (state) {
        const user = state.user;
        //! se utiliza para convertir el resultado de la expresión en un valor booleano. 
        //Esto garantiza que la función devuelva directamente true si el usuario tiene el role 'employee' y false en caso contrario.
        return !!(user && user.role && user.role.includes('employee'));
    }



export function username(state, group) {
    return  state.user.username;
}

// Asistente IA, fase 1: dueño o admin (el backend aplica el mismo filtro y además
// recorta las tools por permiso). Cuando se abra a encargados, cambiar acá y allá.
export function puedeUsarAsistente(state, getters, rootState) {
    const role = (state.user && state.user.role) || [];
    const rolOk = role.includes('owner') || role.includes('admin');
    return rolOk && !!(rootState.asistente && rootState.asistente.habilitado);
}

// Solo el rol: sirve para decidir si vale la pena consultar /asistente/estado.
export function rolPermiteAsistente(state) {
    const role = (state.user && state.user.role) || [];
    return role.includes('owner') || role.includes('admin');
}
